<template>
  <div class="home">
    <section class="page-not-found text-center">
      <div class="container">
        <div class="main-logo">
          <RouterLink to="/">
            <img src="../assets/images/main-logo.png" :alt="$t('pageNotFound.mainLogoAlt')" />
          </RouterLink>
          <img src="../assets/images/page-not-found.png" :alt="$t('pageNotFound.bgImgAlt')" class="bg-img" />
        </div>
        <div class="content-wrapper">
          <h2>{{ $t('pageNotFound.error') }}</h2>
          <h1>{{ $t('pageNotFound.errorCode') }}</h1>
          <p>{{ $t('pageNotFound.message1') }}</p>
          <p>{{ $t('pageNotFound.message2') }}</p>
          <RouterLink to="/team" class="btn-style">{{ $t('pageNotFound.buttonText') }}</RouterLink>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>
